import { ScheduledUpcomingInterviewsListType } from "../../../redux/thinksToDo/thinksToDoType";
import AllInterviewTableListData from "./AllInterviewTableListData";
import { EmptyListPage, TableHeader, TableLoader } from "../../commons";
import { THINKS_TO_DO_HEADERS } from "../../../constant/tableHeadersConstants/thingsToDo/thingsToDoListTableHeaders";
import ScrollToTop from "../../commons/ScrollToTop";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";

type AppProps = {
  data: ScheduledUpcomingInterviewsListType[] | [];
  fetching: boolean;
  handleFeedBackModal: (data?: string) => void;
  offset: number;
};

const AllInterviewTableList = ({
  data,
  fetching,
  handleFeedBackModal,
  offset,
}: AppProps) => {
  return (
    <div>
      {fetching && offset === 0 ? (
        <TableLoader Rows={7} ColumnPerRow={7} />
      ) : (
        <div style={{ width: "100%" }}>
          {data?.length > 0 ? (
            <div className="table-bordered disbursment table-responsive">
              <table className="table">
                <thead className=" sticky-table-header">
                  <TableHeader tableHeader={THINKS_TO_DO_HEADERS} />
                </thead>
                <tbody>
                  <AllInterviewTableListData
                    tableHeader={THINKS_TO_DO_HEADERS}
                    data={data}
                    handleFeedBackModal={handleFeedBackModal}
                  />
                  <div style={{ display: fetching ? "none" : "inline" }}>
                    <ScrollToTop />
                  </div>
                  {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                </tbody>
              </table>
            </div>
          ) : (
            !fetching && (
              <EmptyListPage
                title="No Interview List Found!"
                imageWidth="30%"
                showLinkButton={false}
                showAddButton={false}
              />
            )
          )}
        </div>
      )}
    </div>
  );
};

export default AllInterviewTableList;
